module.exports = __webpack_public_path__ + "static/media/57.c966f765.png";